"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import { ExtendedDrop, getDropPreviewImageUrl } from "@/helpers/waves/drop.helpers";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import { useEffect, useMemo, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import Image from "next/image";
import WaveDropPartContentMedias from "../drops/WaveDropPartContentMedias";
import WaveDropPartContentMarkdown from "../drops/WaveDropPartContentMarkdown";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
interface WaveSmallLeaderboardItemContentProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveSmallLeaderboardItemContent: React.FC<WaveSmallLeaderboardItemContentProps> = t0 => {
  const $ = _c(41);
  const {
    drop,
    onDropClick,
    contentPresentation: t1
  } = t0;
  const contentPresentation = t1 === undefined ? "default" : t1;
  const contentRef = useRef(null);
  const [showGradient, setShowGradient] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (contentRef.current) {
        setShowGradient(contentRef.current.scrollHeight > 208);
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== drop) {
    t3 = [drop];
    $[1] = drop;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== drop.metadata) {
    t4 = getDropPreviewImageUrl(drop.metadata);
    $[3] = drop.metadata;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const previewImageUrl = t4;
  const isStorm = drop.parts.length > 1;
  const haveMetadata = !!drop.metadata.length;
  let t5;
  if ($[5] !== drop.parts) {
    t5 = drop.parts.filter(_temp);
    $[5] = drop.parts;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const haveMedia = !!t5.length;
  let t6;
  if ($[7] !== drop.parts[0] || $[8] !== previewImageUrl) {
    t6 = previewImageUrl ? <div className="tw-flex tw-w-full tw-justify-center"><div className="tw-relative tw-aspect-[4/3] tw-max-h-48 tw-w-full tw-max-w-[264px] tw-overflow-hidden tw-rounded-lg"><Image src={getScaledImageUri(previewImageUrl, ImageScale.AUTOx450)} alt="Preview image" fill={true} sizes="264px" className="tw-object-contain" /></div></div> : !!drop.parts[0]?.media.length && <WaveDropPartContentMedias activePart={drop.parts[0]} disableMediaInteraction={true} imageScale={ImageScale.AUTOx450} />;
    $[7] = drop.parts[0];
    $[8] = previewImageUrl;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== contentPresentation || $[11] !== drop) {
    t7 = <WaveDropPartContentMarkdown mentionedUsers={drop.mentioned_users} mentionedGroups={drop.mentioned_groups} mentionedWaves={drop.mentioned_waves} referencedNfts={drop.referenced_nfts} part={drop.parts[0]} wave={drop.wave} drop={drop} onQuoteClick={_temp2} contentPresentation={contentPresentation} />;
    $[10] = contentPresentation;
    $[11] = drop;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== showGradient) {
    t8 = showGradient && <div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-z-[1] tw-h-12 tw-bg-gradient-to-t tw-from-iron-900 tw-via-iron-900 tw-to-transparent" />;
    $[13] = showGradient;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== onDropClick || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <div ref={contentRef} onClick={onDropClick} className="tw-relative tw-max-h-52 tw-cursor-pointer tw-space-y-3 tw-overflow-hidden">{t6}{t7}{t8}</div>;
    $[15] = onDropClick;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== drop.id || $[21] !== drop.parts[0]?.media || $[22] !== haveMedia) {
    t10 = haveMedia && <MediaTypeBadge mimeType={drop.parts[0]?.media[0]?.mime_type} dropId={drop.id} size="sm" />;
    $[20] = drop.id;
    $[21] = drop.parts[0]?.media;
    $[22] = haveMedia;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== drop.id || $[25] !== isStorm) {
    t11 = isStorm && <><svg className="tw-size-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-tooltip-id={`wave-storm-${drop.id}`}><path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-storm-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Storm</span></Tooltip></>;
    $[24] = drop.id;
    $[25] = isStorm;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== drop.id || $[28] !== haveMetadata) {
    t12 = !!haveMetadata && <><svg className="tw-size-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-metadata-${drop.id}`}><path d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-metadata-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Metadata</span></Tooltip></>;
    $[27] = drop.id;
    $[28] = haveMetadata;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== drop.id || $[31] !== haveMedia) {
    t13 = !!haveMedia && <><svg className="tw-size-3.5 tw-flex-shrink-0 tw-text-iron-400" viewBox="0 0 24 24" aria-hidden="true" fill="none" data-tooltip-id={`wave-media-${drop.id}`}><path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><Tooltip id={`wave-media-${drop.id}`} place="top" style={{
        backgroundColor: "#1F2937",
        color: "white",
        padding: "4px 8px",
        zIndex: 10
      }}><span className="tw-text-xs">Media</span></Tooltip></>;
    $[30] = drop.id;
    $[31] = haveMedia;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = <div className="tw-mt-3 tw-flex tw-items-center tw-gap-x-2">{t10}{t11}{t12}{t13}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t14 || $[39] !== t9) {
    t15 = <div>{t9}{t14}</div>;
    $[38] = t14;
    $[39] = t9;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
};
function _temp(part) {
  return !!part.media.length;
}
function _temp2() {}